import {Field} from 'formik';

import {
    FormikNumberInput,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset,
} from '@flexinet/ui-components';
import {Stack} from '@mantine/core';

import {WeightedActionCodesField} from './WeightedActionCodesField.tsx';
import {TestDefinitionsField} from './TestDefinitionsField.tsx';

export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Persona Details'}>
                <Field
                    name='name'
                    label='Name'
                    description='Human-friendly name, e.g. "Email User"'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='What this persona represents'
                    component={FormikTextarea}
                    my={'xl'}
                />
            </PlatformFieldset>

            {/* ⚠️ READ BEFORE CHANGING EITHER OF THE TWO FIELDSETS BELOW.
                `testDefinitionIds` (Test Definitions) is what the executor
                ACTUALLY RUNS — a wake resolves the persona's test definitions.
                `actionCodes` (Action Codes) is DEPRECATED: the executor no
                longer reads it, and FNP-968 removes it from the schema. It is
                retained here on purpose so the existing form keeps working
                through the transition.
                So: if a persona is running the wrong thing, the field to change
                is Test Definitions, NOT Action Codes. */}
            <PlatformFieldset legend={'Test Definitions'}>
                <TestDefinitionsField/>
            </PlatformFieldset>

            <PlatformFieldset legend={'Behaviour (deprecated)'}>
                <WeightedActionCodesField/>
            </PlatformFieldset>

            <PlatformFieldset legend={'Lifecycle'}>
                {/* All three are NonNull inside PersonaLifecycleInput, so the object is
                    sent only when every field is filled in — fill all three, or leave
                    all three empty. Existing personas may have lifecycle: NULL. */}
                <Field
                    name='lifecycle.wakeCadenceHours'
                    label='Wake Cadence (hours)'
                    description='How often this persona wakes and performs its actions'
                    component={FormikNumberInput}
                    min={1}
                    allowDecimal={false}
                    my={'xl'}
                />

                <Field
                    name='lifecycle.expectedLifespanDays'
                    label='Expected Lifespan (days)'
                    description='How long a synthetic user of this persona is expected to live'
                    component={FormikNumberInput}
                    min={1}
                    allowDecimal={false}
                    my={'xl'}
                />

                <Field
                    name='lifecycle.cancellationLikelihoodPercent'
                    label='Cancellation Likelihood (%)'
                    description='Chance this persona cancels rather than lapsing, 0-100'
                    component={FormikNumberInput}
                    min={0}
                    max={100}
                    allowDecimal={false}
                    my={'xl'}
                />
            </PlatformFieldset>
        </Stack>
    );
};
